import { Component, OnInit } from '@angular/core';
import { News } from '../../model/news.model';
import { ApiService } from '../../services/api.service';
import { Tabs } from './tabs';

@Component({
  selector: 'ngx-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  public news: News[];
  tabs = Tabs;
  constructor(private _apiService: ApiService) { }

  ngOnInit(): void {
    this.getNews();
  }
  getNews() {
    // Refactor this, allow for in service chosing of sort method - for now leave it like this
    // ?sort[0]=id:desc means that the first sort is by ID and is descending
    // If another sort is needed, can add '&sort[1]=xy:asc' for sorting by xy in ascending order.
    this._apiService.getNews('?sort[0]=id:desc').subscribe((res) => {

      if(res['data']){
      // Slice to get LAST 3 news, since it's always sorted by id desc it will return by latest
        this.news = res['data'].slice(0,3);
      }
      else{
        return false;
      }
    })
    
    
  }

}
